import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreMaterialModule } from '@nttp/core-material';
import { ChangePasswordComponent } from '@pg-app/common/change-password/change-password.component';
import { CoreUiModule } from '@nttp/core-ui';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [CommonModule, CoreMaterialModule, CoreUiModule, ReactiveFormsModule],
    declarations: [ChangePasswordComponent],
})
export class ChangePasswordModule { }

